import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";

// Actions
import { logoutAction } from "./logOut.action";

@Injectable()

export class LogOutService {
    constructor(private store: Store) {}

    // This method clears all the stores data after log out
    clearStores(): void {
        this.store.dispatch(logoutAction());
    }
}